import { IPaymentResponse } from '@app/core/models/payments.model';

export const MOCK_PAYMENTS_SUCCESS: IPaymentResponse = {
  loan_id: '123456789',
  status: 'active',
};
